import { UpgradePlanDialog } from 'carrier/loads/core/UpgradePlanDialog';
import { Outlet, RouteObject, useNavigate } from 'react-router-dom';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';
import { lazyImport } from 'shared/routing/LazyRoute';
import { useLandingPath } from 'shared/routing/TMSLandingPath';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { ClaimsRouteGuard } from './core/ClaimsRouteGuard';

const ClaimsPage = lazyImport(() => import('./ClaimsPage'), 'ClaimsPage');
const ClaimDetailsPage = lazyImport(
  () => import('./ClaimDetailsPage'),
  'ClaimDetailsPage',
);

function ClaimsOutlet() {
  const navigate = useNavigate();
  const landingPath = useLandingPath();
  const { data: settings } = useCarrierSettings();

  const isClaimsLocked = settings?.can_open_claim === false;

  return (
    <ClaimsRouteGuard>
      <PermissionView name="claims" permission="can_view">
        <>
          <UpgradePlanDialog
            open={isClaimsLocked}
            onClose={() => {
              navigate(landingPath, { replace: true });
            }}
            type="claims"
            source="Claims"
          />
          <Outlet />
        </>
      </PermissionView>
    </ClaimsRouteGuard>
  );
}

export const claimsRoutes: RouteObject[] = [
  {
    path: 'claims',
    element: <ClaimsOutlet />,
    children: [
      { index: true, element: <ClaimsPage /> },
      { path: ':guid', element: <ClaimDetailsPage /> },
    ],
  },
];
